import { render } from "./ParserStatus.vue?vue&type=template&id=2a914b0a&scoped=true"
import script from "./ParserStatus.vue?vue&type=script&lang=js"
export * from "./ParserStatus.vue?vue&type=script&lang=js"

import "./ParserStatus.vue?vue&type=style&index=0&id=2a914b0a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a914b0a"]])

export default __exports__